import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'usage';

export const fetchUsageData = createAction(`${ACTION_PREFIX}/FETCH_USAGE_DATA`);
export const fetchUsageDataSuccess = createAction(`${ACTION_PREFIX}/FETCH_USAGE_DATA_SUCCESS`);
export const fetchUsageDataFailed = createAction(`${ACTION_PREFIX}/FETCH_USAGE_DATA_FAILED`);

export const exportUsageList = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST`);
export const exportUsageListInProgress = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST_IN_PROGRESS`);
export const exportUsageListReady = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST_READY`);
export const exportUsageListSucceeded = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST_SUCCEEDED`);
export const exportUsageListFailed = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST_FAILED`);

export const fetchUsageAnalytics = createAction(`${ACTION_PREFIX}/FETCH_USAGE_ANALYTICS`);
export const fetchUsageAnalyticsSuccess = createAction(`${ACTION_PREFIX}/FETCH_USAGE_ANALYTICS_SUCCESS`);
export const fetchUsageAnalyticsFailed = createAction(`${ACTION_PREFIX}/FETCH_USAGE_ANALYTICS_FAILED`);

export const onFilterChange = createAction(`${ACTION_PREFIX}/ON_FILTER_CHANGE`);

export const UsageActions = {
  fetchUsageData,
  fetchUsageDataSuccess,
  fetchUsageDataFailed,

  exportUsageList,
  exportUsageListInProgress,
  exportUsageListReady,
  exportUsageListSucceeded,
  exportUsageListFailed,

  fetchUsageAnalytics,
  fetchUsageAnalyticsSuccess,
  fetchUsageAnalyticsFailed,

  onFilterChange,
};
